<template>
  <full-container>
    <el-table v-loading="loading" :data="datalist" row-key="Id" height="100%" default-expand-all>
      <el-table-column label="名称" min-width="180" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span :class="row.Icon"> {{ row.Sort }}.{{ row.Title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Path" label="路径" min-width="150" />
      <el-table-column prop="Component" label="组件" min-width="150" />
      <el-table-column prop="Redirect" label="重定向" min-width="150" />
      <el-table-column label="显示" min-width="60" align="center">
        <span slot-scope="{ row }" v-html="$utils.common.formatBool(row.State)"></span>
      </el-table-column>
      <el-table-column width="150">
        <template slot="header">
          <el-link type="primary" icon="el-icon-plus" @click="openForm()">新增</el-link>
        </template>
        <template slot-scope="{ row }">
          <el-link type="primary" icon="el-icon-edit" @click="openForm(row.Id)">修改</el-link>
          <el-link v-if="!row.children" type="danger" icon="el-icon-delete" @click="deleteData(row.Id)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
  </full-container>
</template>

<script>
import formpage from './form'
export default {
  name: 'modules',
  data () {
    return {
      datalist: [],
      queryParams: {},
      loading: false,
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    //获取数据列表
    loadData () {
      this.loading = true
      return this.$apis.system.menu.getTree({
        parentId: null, state: null
      }).then((res) => {
        this.datalist = res
      }).finally(() => {
        this.loading = false
      })
    },
    //编辑
    openForm (id) {
      this.$layer.iframe({
        title: '菜单编辑',
        area: ['600px', 'auto'],
        content: {
          content: formpage,
          parent: this,
          data: { id: id },
        },
      })
    },
    //删除数据
    deleteData (id) {
      this.$confirm('此操作将永久删除数据, 是否继续?', '删除模块', {
        center: true,
      }).then(() => {
        this.loading = true
        this.$apis.system.menu.delete({ id: id }).then((res) => {
          this.loadData()
          this.$message({ message: res || '数据删除成功！', type: 'success' })
        })
      }).catch(e => {
        this.$message.console.error(e || '数据删除失败！')
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

